/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_RetriesInputs */

const en_svchip_retries = /** @type {(inputs: Svchip_RetriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retries`)
};

const ar_svchip_retries = /** @type {(inputs: Svchip_RetriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المحاولات المتكررة`)
};

const bn_svchip_retries = /** @type {(inputs: Svchip_RetriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিট্রাই`)
};

const de_svchip_retries = /** @type {(inputs: Svchip_RetriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholungsversuche`)
};

const es_svchip_retries = /** @type {(inputs: Svchip_RetriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reintentos`)
};

const fr_svchip_retries = /** @type {(inputs: Svchip_RetriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelles tentatives`)
};

const pt_svchip_retries = /** @type {(inputs: Svchip_RetriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novas tentativas`)
};

const zh_svchip_retries = /** @type {(inputs: Svchip_RetriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

const tr_svchip_retries = /** @type {(inputs: Svchip_RetriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeniden denemeler`)
};

const ru_svchip_retries = /** @type {(inputs: Svchip_RetriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторные попытки`)
};

const pl_svchip_retries = /** @type {(inputs: Svchip_RetriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponowne próby`)
};

/**
* | output |
* | --- |
* | "Retries" |
*
* @param {Svchip_RetriesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_retries = /** @type {((inputs?: Svchip_RetriesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_RetriesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_retries(inputs)
	if (locale === "bn") return bn_svchip_retries(inputs)
	if (locale === "de") return de_svchip_retries(inputs)
	if (locale === "es") return es_svchip_retries(inputs)
	if (locale === "fr") return fr_svchip_retries(inputs)
	if (locale === "pt") return pt_svchip_retries(inputs)
	if (locale === "zh") return zh_svchip_retries(inputs)
	if (locale === "tr") return tr_svchip_retries(inputs)
	if (locale === "ru") return ru_svchip_retries(inputs)
	if (locale === "pl") return pl_svchip_retries(inputs)
	return en_svchip_retries(inputs)
});